import React from "react";
import styles from "./PackagesTypesDetail.module.css";
import ModalQ from "../../../components/TableBionovaQ/ModalQ/ModalQ";
import materialImg from "../../../components/NavBar/Menu/icons/INSTRUMENTS.svg";
import DetailPackages from "../../../components/PackagesGenerator/detailPackages";

const PackagesTypesDetail = ({ modelData, t, locale, handleClose, open, getMachineTypeName }) => {
  console.log(modelData)
  return (
    <ModalQ handleClose={handleClose} open={open} title={"Package Type Detail"}>
      <div className={styles.detailContainer}>
        <div className={styles.inputGroup}>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("TypeofPackages", locale) || "Type of Packages"}:
            </label>
            <div className={styles.detailValue}>{modelData.name || "-"}</div>
          </div>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("Method", locale) || "Method"}:
            </label>
            <div className={styles.detailValue}>{modelData.method?.name || "-"}</div>
          </div>
        </div>

        <div className={styles.inputGroup}>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("Description", locale) || "Description"}:
            </label>
            <div className={styles.detailValue}>
              {modelData.description || "-"}
            </div>
          </div>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("Observations", locale) || "Observations"}:
            </label>
            <div className={styles.detailValue}>
              {modelData.observations || "-"}
            </div>
          </div>
        </div>
          <DetailPackages
          materials={modelData.materials} >
          </DetailPackages>
      </div>
    </ModalQ>
  );
};

export default PackagesTypesDetail;